import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/views/customer/Home.vue';
import { useAppStore } from '@/stores/appstore';
import NProgress from 'nprogress';
NProgress.configure({ easing: 'ease', speed: 1500 });


const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            requiresAuthentication: false,
        }
    },

    {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import('@/views/customer/About.vue'),
        meta: {
            requiresAuthentication: false,
        }
    },
    {
        path: '/faq',
        name: 'Frequently Asked Question',
        component: () => import('@/views/customer/faq.vue'),
        meta: {
            requiresAuthentication: false,
        }

    },
    {
        path: '/terms',
        name: 'Terms',
        component: () => import('@/views/customer/terms.vue'),
        meta: {
            requiresAuthentication: false,
        }

    },
    {
        path: '/privacy',
        name: 'Privacy',
        component: () => import('@/views/customer/privacy.vue'),
        meta: {
            requiresAuthentication: false,
        }

    },
    {
        path: '/why-host',
        name: 'Why host',
        component: () => import('@/views/customer/why-host.vue'),
        meta: {
            requiresAuthentication: false,
        }

    },

    {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('@/views/shared/dashboard.vue'),
        meta: {
            requiresAuthentication: true,
        }

    },
    {
        path: '/why-rent',
        name: 'Why rent',
        component: () => import('@/views/customer/why-rent.vue'),
        meta: {
            requiresAuthentication: false,
        }

    },
    {
        path: '/profile',
        name: 'Profile page',
        component: () => import('@/components/dashboard/profile.vue'),
        meta: {
            requiresAuthentication: false,
        }

    },
    {
        path: '/dashboard/invoice',
        name: 'subscriber-invoice',
        component: () => import('@/components/dashboard/subscriber/invoice.vue'),
        meta: {
            requiresAuthentication: true,
        }
    },
    {
        path: '/dashboard/request/schedule-inspection',
        name: 'schedule-inspection',
        component: () => import('@/components/dashboard/subscriber/schedule-inspection.vue'),
        meta: {
            requiresAuthentication: true,
        }
    },
    {
        path: '/dashboard/subscriber-history',
        name: 'subscriber-history',
        component: () => import('@/components/dashboard/subscriber/subscription-history.vue'),
        meta: {
            requiresAuthentication: true,
        }
    },

    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/shared/login.vue'),
        meta: {
            hideNavbar: true,
            hideFooter: true,
            requiresAuthentication: false,
        }
    },

    {
        path: '/signup/:type',
        name: 'SignUp',
        component: () => import('@/views/customer/sign-up.vue'),
        meta: {
            hideNavbar: true,
            hideFooter: true,
            requiresAuthentication: false,
        }
    },

    {
        path: '/host/add-listing',
        name: 'add-listing',
        component: () => import('@/views/customer/add-listing.vue'),
        meta: {
            hideNavbar: true,
            hideFooter: true,
            // requiresAuthentication: true,
            // requiredRoles: ['host', 'admin']
        }
    },

    {
        path: '/rent-calculator',
        name: 'rent calculator',
        component: () => import('@/views/customer/rent-calculator.vue')

    },
    {
        path: '/community',
        name: 'community',
        component: () => import('@/views/customer/community.vue'),
        meta: {
            hideNavbar: false,
            hideFooter: false,
            requiresAuthentication: false           
        }

    },
    {
        path: '/forgotpassword',
        name: 'forgot password',
        component: () => import('@/views/shared/forgotpassword.vue')

    },
    {
        path: '/confirm/:email/:token',
        name: 'email-confirmed',
        component: () => import('@/views/shared/email-confirmed.vue'),
        meta: {
            hideNavbar: true,
            hideFooter: true,
            requiresAuthentication: false,
        }
    },
    {
        path: '/verify-email/:email?',
        name: 'otp-verification',
        component: () => import('@/views/shared/otp-verification.vue'),
        meta: {
            hideNavbar: true,
            hideFooter: true,
            requiresAuthentication: false,
        }
    },
    {
        path: '/listing/detail/:reference',
        name: 'room-detail',
        component: () => import('@/views/shared/room-detail.vue'),
        meta: {
            title: (route) => {
                let reference = route.params.reference;
                return `Details for room #${reference}`;
            }
        }
    },
    {
        path: '/listing/sendrequest/:reference',
        name: 'send-request',
        component: () => import('@/views/customer/request-page.vue'),
        meta: {
            title: (route) => {
                let reference = route.params.reference;
                return `Send a subscription request for listing #${reference}`;
            }
        }
    },

    {
        path: '/search/:city/:latitude?/:longitude?',
        name: 'search-results',
        component: () => import('@/views/customer/listing-search-results.vue'),
        meta: {
            title: (route) => {
                let city = route.params.city;
                return `Search results for rooms in ${city}`;
            }
        }
    },
    {
        path: '/subscriber/all-requests',
        name: 'all-requests',
        component: () => import('@/components/dashboard/subscriber/all-requests.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/host/all-requests',
        name: 'host-all-requests',
        component: () => import('@/components/dashboard/host/all-requests.vue'),
        meta: { requiresAuthentication: true }
    },
    {
        path: '/host/all-listings',
        name: 'host-all-listings',
        component: () => import('@/components/dashboard/host/all-listings.vue'),
        meta: { requiresAuthentication: true }
    },

]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({ left: 0, top: 0 })
            }, 200)
        })
    }
});

//Todo: Add check for authentication token expiry
router.beforeEach((to, from) => {
    NProgress.start();
    const store = useAppStore();
    //Checks authentication for pages that require the user to be logged in
    if (!store.IsAuthenticated && to.meta.requiresAuthentication === true) {
        NProgress.done();
        return { name: 'Login' };
    }

    //Check user roles for pages that require specific roles
    if (to.meta.requiredRoles && Array.isArray(to.meta.requiredRoles)) {
        const userRole = store.User.userType.toLowerCase(); // Adjust this to your actual user role property
        if (!userRole || !to.meta.requiredRoles.includes(userRole)) {
            NProgress.done();
            return { name: 'Home' };
        }
    }
    NProgress.done();

})

export default router
